import { Navigate, Outlet } from 'react-router'
import { usePermission } from '@/hooks/usePermission'

/**
 * Route-level permission gate.
 *
 * Convenience and clarity only — the backend enforces the same permission on every
 * endpoint, so a user who edits the URL reaches a page that returns 403s.
 */
export function RequirePermission({ permission }: { permission: string }) {
  return usePermission(permission) ? <Outlet /> : <Navigate to="/forbidden" replace />
}
